import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { DetalleBono } from './components/detalleBono';

const BonosPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: "/configuracion/historial",
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'Bonos',
      path: location.pathname,
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Detalle Bonos</PageTitle>
      <DetalleBono/>
    </>
  );
};

export {BonosPage}